import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Api from '../../../api/Api';
import './LocationCheckPage.css';
import routeNames from '../../../constants/routeNames';
import { useContent, useLoading, useLocationContext } from '../../../hooks/customHooks';
import routeHelper from '../../../helpers/routeHelper';
import { CampaignTypes } from '../../../constants/CampaignTypes';
import { ErrorStatusTypes } from '../../../constants/ErrorStatusTypes';
import { JourneyTypes } from '../../../constants/JourneyTypes';

function LocationCheckPage() {
    const navigate = useNavigate();
    const { byUser, userLocation, getMyLocation, selectedLocation, updateLocationContext } =
        useLocationContext();
    const params = useParams();
    const location = useLocation();

    const [firstTime, setFirstTime] = useState(true);
    const [serve, setServe] = useState(null);
    const [uniqueData, setUniqueData] = useState({});
    const { setLoading } = useLoading();
    const { content } = useContent();
    const [userCheckPassed, setUserCheckPassed] = useState(false);
    const { journey } = content;

    const forwardTo = state => {
        const { voucher, instantWin } = journey;
        let route = '';
        let props = { state };

        if (voucher && !uniqueData?.journeyContinues && !location?.state?.skipVoucher) {
            route = routeNames.REDEEM;
        } else if (instantWin) {
            route = `/instant-win/check/${params?.unique}`;
        } else {
            route = routeNames.REDEEM_SUCCESS;
        }
        navigate(route, props);
    };

    useEffect(() => {
        window.scrollTo({ top: 0 });
        (async () => {
            getMyLocation();
            setLoading(true);
            if (params?.unique && params?.type) {
                const uniqueResponse = await Api.checkUnique(params?.unique);
                const selectedVenue = await Api.getSelectedVenue(params?.unique);

                if (uniqueResponse?.result && uniqueResponse?.data?.journeyContinues) {
                    if (
                        uniqueResponse?.data?.destination === JourneyTypes.INSTANT_WIN &&
                        uniqueResponse?.data?.instantWinActivated
                    ) {
                        navigate(`/instant-win/check/${params?.unique}`);
                        return;
                    } else if (uniqueResponse?.data?.destination === JourneyTypes.GAME) {
                        navigate(`/game/location-check/${params?.unique}`);
                        return;
                    }
                }

                if (uniqueResponse?.data?.swiped && !journey?.instantWin) {
                    const state = {
                        unique: params?.unique,
                        type: params?.type,
                        venueId: selectedVenue.data._id,
                        firstTime: false,
                        uniqueData: uniqueResponse.data,
                        serve: uniqueResponse?.extra?.serve ?? uniqueResponse?.data?.serve,
                        callbackUrl: location?.state?.callbackUrl,
                    };
                    forwardTo(state);
                    return;
                }

                if (uniqueResponse?.data) {
                    setFirstTime(false);
                    setUniqueData(uniqueResponse.data);
                }
                if (uniqueResponse?.result) {
                    updateLocationContext({
                        selectedLocation: selectedVenue?.data,
                        nearbyLocations: [selectedVenue?.data],
                    });
                    setServe(uniqueResponse?.extra?.serve);
                    setUserCheckPassed(true);
                } else if (uniqueResponse?.error?.type) {
                    if (
                        uniqueResponse?.error?.type ===
                            ErrorStatusTypes.ALREADY_REDEEMED_NO_LIMIT &&
                        content?.type === CampaignTypes.GAME_AT_THE_END
                    ) {
                        navigate(`/game/location-check/${params?.unique}`);
                    } else {
                        if (location?.state?.skipVoucher) {
                            if (uniqueResponse?.error.data?.instantWinActivated) {
                                navigate(`/instant-win/check/${params?.unique}`);
                            } else {
                                updateLocationContext({
                                    selectedLocation: selectedVenue?.data,
                                    nearbyLocations: [selectedVenue?.data],
                                });
                                setUserCheckPassed(true);
                            }
                        } else {
                            routeHelper(
                                uniqueResponse.error.type,
                                content,
                                navigate,
                                null,
                                uniqueResponse
                            );
                        }
                    }
                } else {
                    navigate(routeNames.ALREADY_REDEEMED, {
                        state: {
                            type: uniqueResponse?.error?.type,
                        },
                    });
                }
            } else {
                if (!selectedLocation) {
                    navigate(routeNames.HOME);
                }
            }
        })();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        setLoading(true);
        if (byUser && userLocation) {
            if (selectedLocation && userCheckPassed) {
                (async () => {
                    let distanceResponse = await Api.getDistanceBetween({
                        from: `${userLocation.lat},${userLocation.lng}`,
                        to: `${selectedLocation.latitude},${selectedLocation.longitude}`,
                        venueId: selectedLocation._id,
                    });
                    if (distanceResponse && distanceResponse.result) {
                        if (distanceResponse.data && distanceResponse.data.isInArea) {
                            const state = {
                                unique: params?.unique,
                                type: params?.type,
                                venueId: selectedLocation._id,
                                firstTime,
                                uniqueData,
                                serve: serve,
                                token: location?.state?.token,
                                callbackUrl: location?.state?.callbackUrl,
                            };
                            forwardTo(state);
                        } else {
                            navigate(`/location-error/${params?.unique}/${params?.type}`, {
                                state: location?.state,
                            });
                        }
                    } else {
                        getMyLocation();
                    }
                })();
            }
        } else {
            getMyLocation();
        }

        // eslint-disable-next-line
    }, [userLocation, selectedLocation, userCheckPassed]);

    return (
        <div className={`loading-wrapper`}>
            <div className="loading-spinner" />
        </div>
    );
}

export default LocationCheckPage;
